// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type RemoveChatFileMutationVariables = Types.Exact<{
  fileId: Types.Scalars['ID']['input'];
}>;


export type RemoveChatFileMutation = { __typename?: 'Mutation', removeChatFile: { __typename?: 'ChatFile', id: string, status: Types.ChatFileStatus } };


export const RemoveChatFileDocument = gql`
    mutation RemoveChatFile($fileId: ID!) {
  removeChatFile(fileId: $fileId) {
    id
    status
  }
}
    `;

/**
 * __useRemoveChatFileMutation__
 *
 * To run a mutation, you first call `useRemoveChatFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChatFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChatFileMutation, { data, loading, error }] = useRemoveChatFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRemoveChatFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveChatFileMutation, RemoveChatFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveChatFileMutation, RemoveChatFileMutationVariables>(RemoveChatFileDocument, options);
      }
export type RemoveChatFileMutationHookResult = ReturnType<typeof useRemoveChatFileMutation>;
export type RemoveChatFileMutationResult = ApolloReactCommon.MutationResult<RemoveChatFileMutation>;